import { lazy } from "react";
import Icon from "../../components/Icon";

const Faq = lazy(() => import("./Faq"));
const Learning = lazy(() => import("./Learning"));
const SlaDownload = lazy(() => import("./SlaDownload"));

let HelpRoutes = [
  {
    path: "/help/faq",
    exact: false,
    title: "سوالات متداول",
    sidebar: true,
    iconTag: <Icon name={"question"} className={"drawerIcons large"} />,
    component: Faq,
    roles: ["LIMITED"],
  },
  {
    path: "/help/learning",
    exact: false,
    title: "آموزش",
    sidebar: true,
    iconTag: <Icon name={"faq"} className={"drawerIcons large"} />,
    component: Learning,
    roles: ["LIMITED"],
  },
  {
    path: "/help/sla",
    exact: false,
    title: "موافقت‌نامه سطح خدمات (SLA)",
    sidebar: true,
    component: SlaDownload,
    iconTag: <Icon name={"deposits-list"} className={"drawerIcons large"} />,
    roles: ["LIMITED"],
  },
];

export default HelpRoutes;
